import ChannelThemeProvider from "./ChannelThemeProvider";
import ChannelThemeContext from "./context";

export default ChannelThemeContext;
export { ChannelThemeProvider };
